import React, { useMemo } from 'react';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';

// Only the WIP outlet is wrapped: other modules, navigation chrome and printed labels stay unchanged.
export default function WipTextTheme({ children }) {
  const parent = useTheme();
  const theme = useMemo(() => createTheme(parent, {
    typography: {
      body1: { fontSize: '1.25rem', lineHeight: 1.5 },
      body2: { fontSize: '1.125rem', lineHeight: 1.5 },
      caption: { fontSize: '1rem', lineHeight: 1.4 },
      subtitle1: { fontSize: '1.375rem', lineHeight: 1.4 },
      subtitle2: { fontSize: '1.25rem', lineHeight: 1.4 },
      button: { fontSize: '1.125rem', lineHeight: 1.4 },
    },
    components: {
      MuiInputBase: { styleOverrides: { root: { fontSize: '1.25rem' } } },
      MuiInputLabel: { styleOverrides: { root: { fontSize: '1.25rem' } } },
      MuiFormHelperText: { styleOverrides: { root: { fontSize: '1rem', lineHeight: 1.5 } } },
      MuiMenuItem: { styleOverrides: { root: { fontSize: '1.25rem', minHeight: 48, whiteSpace: 'normal' } } },
      MuiButton: { styleOverrides: { root: { minHeight: 44, fontSize: '18px', lineHeight: 1.4, textTransform: 'none', letterSpacing: 'normal' } } },
      MuiTableCell: { styleOverrides: { root: { fontSize: '1.125rem', lineHeight: 1.5 } } },
      MuiChip: { styleOverrides: { root: { fontSize: '1rem', height: 'auto', minHeight: 28 }, label: { whiteSpace: 'normal' } } },
      MuiTablePagination: { styleOverrides: { selectLabel: { fontSize: '1rem' }, displayedRows: { fontSize: '1rem' } } },
    },
  }), [parent]);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
